import { drupalComponent } from '@nech/src/helpers/drupal-component';
import { trapFocus, TrapFocusCleanup } from '@nech/src/helpers/function-helpers';

//breakpoint
const isTabletMobile = window.innerWidth < 1024;

//class Menu states
const classMenuWindowOpen = 'translate-x-0';
const classMenuWindowClose = '-translate-x-full';

//menu content
const $topNavMenuLvl1 = '.nav-menu--top-nav-level-1';
const $topNavMenuLvl2 = '.top-menu-nav-2';
const $topMenuNavLevel3 = '.top-menu-nav-3';
const $firstLvlLabel = '.first-level-label';
const $secondLvlLabel = '.second-level-label';
const $thirdLvlLabel = '.third-level-label';
const $fourthLvlLabel = '.fourth-level-label';
const $iconShowListLastLvl = '.nav-menu--icon-show-links-last-level';
const $navArrowIcon = '.nav-menu--arrow-icon-second-level';

//menus levels
const $menuLvl2 = '.menu-level-2';
const $menuLvl3 = '.menu-level-3';
const $menuLvl4 = '.menu-level-4';

(function (Drupal, $) {
  drupalComponent('nechNavigationMenu', {
    selector: '.navigation-menu > .nech-navigation-menu',

    shared: {
      toggleMenu: function (
        $el: JQuery<HTMLElement>,
        tabIcon?: string,
        tabLabel?: string,
        subTabLabel?: string,
      ) {
        const activeMenuLvl2 = $el.hasClass('menu-level-2');
        const activeMenuLvl3 = $el.hasClass('menu-level-3');

        // click on 1st LEVEL
        if (activeMenuLvl2) {
          const $topMenuNavLevel2 = $($topNavMenuLvl2);
          const menuLvl2Hidden = $el.hasClass(classMenuWindowClose);

          //remove max width window lvl1
          $('.nech-navigation-menu').removeClass('lg:max-w-[440px]').addClass('lg:max-w-[400px]');

          //tabindex and aria hidden attr
          $el.find($secondLvlLabel).removeAttr('aria-hidden');
          $el.find($topNavMenuLvl2).find('a').removeAttr('aria-hidden');
          $el.find($secondLvlLabel).removeAttr('tabindex');
          $el.find($topNavMenuLvl2).removeAttr('tabindex');
          $el.find($topNavMenuLvl2).find('a').attr('tabindex', '0');

          //hide navtop header first level
          $($topNavMenuLvl1).addClass('hidden');
          //replace label and icon topmenunav
          $topMenuNavLevel2.find('.top-menu-nav-2-heading').text(tabLabel ?? '');
          $topMenuNavLevel2
            .find('.top-menu-nav-2-heading')
            .attr(
              'aria-label',
              tabLabel ? `Les onglets cliquables du menu au niveau ${tabLabel}` : null,
            );
          $topMenuNavLevel2
            .find('.top-menu-nav-2-content')
            .find('span')
            .addClass(`${tabIcon} text-3xl`);

          $topMenuNavLevel2
            .find('.seeAllLink')
            .attr('aria-label', `Lien de redirection pour la page ${tabLabel}`);

          $($firstLvlLabel).addClass('hidden');
          //$el = SENCOND UL
          if (menuLvl2Hidden) {
            $topMenuNavLevel2.removeClass('hidden').addClass('block');

            $el.addClass('classOpenWindow').removeClass(classMenuWindowClose);
          } else {
            $topMenuNavLevel2.removeClass('block').addClass('hidden');

            $el.removeClass(classMenuWindowOpen).addClass(classMenuWindowClose);
          }
          //CLICK on 2nd LEVEL
          //$el = THIRD UL
        } else if (activeMenuLvl3) {
          //tabindex and aria hidden attr

          $($thirdLvlLabel).css('font-weight', '400');
          $($topMenuNavLevel3)
            .find('.top-menu-nav--icon-back-nav-label')
            .text(tabLabel ?? '');

          $($topMenuNavLevel3)
            .find('.seeAllLink')
            .attr('aria-label', `Lien de redirection pour la page ${tabLabel}`);

          $($topMenuNavLevel3).attr(
            'aria-label',
            tabLabel ? `Les onglets cliquables du menu au niveau ${tabLabel}` : null,
          );
          $($topMenuNavLevel3)
            .find('.top-menu-nav-3-heading')
            .text(subTabLabel ?? '');
          const menuLvl3Hidden = $el.hasClass(classMenuWindowClose);
          const classSowMenuLvl4 = 'opacity-0 h-0';

          $el.find('.top-menu-nav-3').css('min-height', '140px');
          $el.find('.top-menu-nav-2').css('min-height', '140px');

          $($iconShowListLastLvl).removeClass('text-primary-700').addClass('text-neutral-300');

          $($iconShowListLastLvl).css('transform', 'rotate(0deg)');
          $($menuLvl4).each(function () {
            const menuLvl4Hidden = $(this).hasClass('opacity-0');
            if (!menuLvl4Hidden) {
              $(this).addClass(classSowMenuLvl4);
            }
          });

          $($menuLvl2).addClass('lg:w-1/2');
          $($menuLvl3)
            .not($el)
            .removeClass(classMenuWindowOpen)
            .addClass(classMenuWindowClose)
            .css({
              left: '0',
              top: '0',
            });

          if (menuLvl3Hidden) {
            $el
              .addClass(classMenuWindowClose + ' absolute')
              .removeClass(classMenuWindowClose + ' fixed')
              .css({
                left: isTabletMobile ? '0' : '400px',
                top: '0',
              });
          } else if ($el.hasClass(classMenuWindowClose)) {
            $($menuLvl2).removeClass('lg:w-1/2');
          }
        } else {
          $($menuLvl2).removeClass('lg:w-1/2');

          $($menuLvl3).css({
            left: '0',
            top: '0',
          });
        }
      },

      toggleLastLevel: function ($el: JQuery<HTMLElement>) {
        const icon = $el.parent().find('.nav-menu--icon-show-links-last-level');

        $($menuLvl4)
          .not($el)
          .removeClass('opacity-100 h-auto')
          .addClass('opacity-0 h-0 hidden')
          .parent()
          .find('.nav-menu--icon-show-links-last-level')
          .css('transform', 'rotate(0deg)');

        if ($el.hasClass('hidden')) {
          icon.css('transform', 'rotate(90deg)');
          $el.removeClass('hidden opacity-0 h-0').addClass('flex opacity-100 h-auto');
        } else {
          icon.css('transform', 'rotate(0deg)');
          $el.addClass('hidden opacity-0 h-0').removeClass('flex opacity-100 h-auto');
        }
      },

      extractPhClasses: function (str: string) {
        const phClasses = str.split(' ').filter(cls => cls.startsWith('ph'));
        return phClasses.join(' ');
      },
    },

    attach(context) {
      const self = this;
      const $el = $(this.selector, context);
      if (!$el.length || $el.data('nech-nav-menu-attached')) return;
      $el.data('nech-nav-menu-attached', true);
      let currentTrapCleanup: TrapFocusCleanup | null = null;
      let pendingTrapFrame: number | null = null;

      /**
       * Libere le focus trap courant ET la frame en attente.
       *
       * SUA1616-582 : sans annuler la frame, deux appels rapproches a setTrap
       * laissaient un listener keydown orphelin sur document, dont la closure
       * retenait tout un sous-arbre du menu. Le cas se produisait sur
       * 'click keypress' du bouton retour, et sur nech:nav-closed declenche
       * avant que la frame precedente n'ait pose son trap.
       */
      const clearTrap = () => {
        if (pendingTrapFrame !== null) {
          cancelAnimationFrame(pendingTrapFrame);
          pendingTrapFrame = null;
        }
        if (currentTrapCleanup) {
          currentTrapCleanup();
          currentTrapCleanup = null;
        }
      };

      const setTrap = (options: Parameters<typeof trapFocus>[0]) => {
        clearTrap();
        pendingTrapFrame = requestAnimationFrame(() => {
          pendingTrapFrame = null;
          currentTrapCleanup = trapFocus(options);
        });
      };

      const resetSublevels = () => {
        $el.find('.second-level-label, .third-level-label, .fourth-level-label')
          .attr('aria-hidden', 'true')
          .attr('tabindex', '-1');
        $el.find('.top-menu-nav-2, .top-menu-nav-3')
          .find('a, button')
          .attr('aria-hidden', 'true')
          .attr('tabindex', '-1');
      };

      $(document).on('nech:nav-closed', () => {
        clearTrap();
        resetSublevels();
      });
      const $arrowNavBack = $el.find('.nav-back-menu');
      const $menuLevel2 = $el.find('.menu-level-2');
      const $menuLevel3 = $el.find('.menu-level-3');
      const $menuLevel4 = $el.find('.menu-level-4');
      const $previousButtonLastLevel = $el.find('.top-menu-nav-3-back-wrapper');

      $el.find('li.first > .first-level-label ').on('click', function (event) {
        event.stopPropagation();
        $menuLevel2.not($(this).children('.menu-level-2')).addClass(classMenuWindowClose);
        const $submenu = $(this).next('ul.menu-level-2');
        const tabLabel = $(this).text();
        const iconClass = $(this).find('.first-level-icon').attr('class');
        const tabIcon = self.shared.extractPhClasses(iconClass ?? '');
        setTrap({ el: $submenu });
        self.shared.toggleMenu($submenu, tabIcon, tabLabel);
      });

      $el.find('.navigation-menu--li-wrapper > li.second').on('click', function (event) {
        event.stopPropagation();

        const $link = $(this).find('a');
        const href = $link.attr('href');
        if (!href || href === '#' || href === ' ') {
          event.preventDefault();
        }

        $($menuLvl4).each(function () {
          if (!$(this).hasClass('opacity-0')) {
            $(this).addClass('opacity-0 h-0 hidden');
          }
        });
        
        const $arrowIcon = $(this).find('.nav-menu--arrow-icon-second-level');
        const $submenu = $(this).children('.menu-level-3');
        const $subTabLabel = $(this).find('.second-level-label').text();
        const $topNavLvl3 = $el.find('.top-menu-nav-3');
        const $headerThirdLevel = $topNavLvl3.find('.top-menu-nav-3-heading');
        $headerThirdLevel.text($subTabLabel);
        const maxHeightTopNav = 140;
        const $topNavLvl2 = $(this).closest('.menu-level-2').find('.top-menu-nav-2');
        const hasLevel3 = $(this).find('> .menu-level-3').length;

        // SUA1616-582 : une seule passe de lecture puis une ecriture, au lieu
        // de quatre outerHeight() entrelaces avec des ecritures de style, qui
        // forcaient autant de reflows synchrones sur un arbre de 2467 noeuds.
        if (hasLevel3) {
          setTimeout(() => {
            const topNavLvl2Height = $topNavLvl2.outerHeight() ?? 0;
            const topNavLvl3Height = $topNavLvl3.outerHeight() ?? 0;
            if (topNavLvl2Height > maxHeightTopNav) {
              $topNavLvl3.css('min-height', `${topNavLvl2Height}px`);
            } else if (topNavLvl3Height > maxHeightTopNav) {
              $topNavLvl2.css('min-height', `${topNavLvl3Height}px`);
            }
          }, 0);
        }

        $submenu.find($thirdLvlLabel).removeAttr('aria-hidden');
        $submenu.find($topMenuNavLevel3).find('a').removeAttr('aria-hidden');
        $submenu.find($thirdLvlLabel).removeAttr('tabindex');
        $submenu.find($topMenuNavLevel3).find('a').removeAttr('tabindex');

        $menuLevel3.not($submenu).find($thirdLvlLabel).attr('aria-hidden', 'true');
        $menuLevel3.not($submenu).find($thirdLvlLabel).attr('tabindex', '-1');
        $menuLevel3.not($submenu).find($topMenuNavLevel3).find('a').attr('aria-hidden', 'true');
        $menuLevel3.not($submenu).find($topMenuNavLevel3).find('a').attr('tabindex', '-1');

        $menuLevel4.find($fourthLvlLabel).attr('aria-hidden', 'true');
        $menuLevel4.find($fourthLvlLabel).attr('tabindex', '-1');

        $el
          .find('.nav-menu--arrow-icon-second-level')
          .removeClass('text-primary-700')
          .addClass('text-neutral-300');
        $arrowIcon.removeClass('text-neutral-300').addClass('text-primary-700');

        $menuLevel3.not($submenu).addClass(classMenuWindowClose);
        self.shared.toggleMenu($submenu, '', $subTabLabel, $subTabLabel);

        setTimeout(() => {
          if (isTabletMobile) {
            $(this).closest('.menu-level-2').find('a.seeAllLink').attr('aria-hidden', 'true');
          } else {
            $previousButtonLastLevel.addClass('visually-hidden');

          }

          $(this).closest('.menu-level-2').find('a.nav-back-menu').attr('aria-hidden', 'true');
          $(this).closest('.menu-level-2').find($secondLvlLabel).attr('aria-hidden', 'true');
          $(this).closest('.menu-level-4').find($fourthLvlLabel).attr('aria-hidden', 'true');
          $previousButtonLastLevel.removeAttr('aria-hidden').removeAttr('tabindex');
          setTrap({
            el: $(this).find('ul.menu-level-3'),
            forceAutofocusEl: $(this).find('a.seeAllLink')
          });
        }, 0);
      });

      $el.find('.navigation-menu--li-wrapper > li.third').on('click', function (event) {
        event.stopPropagation();
        const $link = $(this).find('a');
        const href = $link.attr('href');
        if (!href || href === '#' || href === ' ') {
          event.preventDefault();
        }
        const $arrowIcon = $(this).find('.nav-menu--icon-show-links-last-level');
        const $submenu = $(this).children('.menu-level-4');
        const $label = $(this).find('.third-level-label');

        if (!href || href === '#' || href === ' ') {
          $label.css('font-weight', '700');

          $el.find('.third-level-label').not($label).css('font-weight', '400');
        } else {
          $label.css('font-weight', '400');
        }
        $el
          .find('.nav-menu--icon-show-links-last-level')
          .removeClass('text-primary-700')
          .addClass('text-neutral-300');

        $arrowIcon.removeClass('text-neutral-300').addClass('text-primary-700');

        self.shared.toggleLastLevel($submenu);

        $submenu.find($fourthLvlLabel).removeAttr('aria-hidden');
        $submenu.find($fourthLvlLabel).removeAttr('tabindex');

        $menuLevel4.not($submenu).find($fourthLvlLabel).attr('aria-hidden', 'true');
        $menuLevel4.not($submenu).find($fourthLvlLabel).attr('tabindex', '-1');

        setTrap({
          el: $(this).closest('.menu-level-3'),
          forceAutofocusEl: $(this).children('.menu-level-4').find('.fourth-level-label').first(),
        });
      });

      $el.find('.fourth-level-label').on('click', function (event) {
        event.stopPropagation();
      });
      $el.find('.seeAllLink').on('click', function (event) {
        event.stopPropagation();
      });

      $arrowNavBack.on('click keypress', function (event) {
        event.preventDefault();
        event.stopPropagation();

        setTrap({ el: $el });

        $($secondLvlLabel).attr('aria-hidden', 'true');
        $($topNavMenuLvl2).find('a').attr('aria-hidden', 'true');
        $($secondLvlLabel).attr('tabindex', '-1');
        $($topNavMenuLvl2).find('a').attr('tabindex', '-1');

        $($thirdLvlLabel).attr('aria-hidden', 'true');
        $($topMenuNavLevel3).find('a').attr('aria-hidden', 'true');
        $($thirdLvlLabel).attr('tabindex', '-1');
        $($topMenuNavLevel3).find('a').attr('tabindex', '-1');

        $($fourthLvlLabel).attr('aria-hidden', 'true');
        $($fourthLvlLabel).attr('tabindex', '-1');

        //reset width nav window
        $('.nech-navigation-menu').removeClass('lg:max-w-[400px]').addClass('lg:max-w-[440px]');

        $el.find('.top-menu-nav-3').css('min-height', '140px');
        $el.find('.top-menu-nav-2').css('min-height', '140px');
        $el.find('.third-level-label').removeClass('paragraph-m-bold').addClass('paragraph-m');

        $($menuLvl4).each(function () {
          if (!$(this).hasClass('opacity-0')) {
            $(this).addClass('opacity-0 h-0 hidden');
          }
        });

        $($topNavMenuLvl1).removeClass('hidden');

        $($iconShowListLastLvl).removeClass('text-primary-700').addClass('text-neutral-300');

        $($navArrowIcon).removeClass('text-primary-700').addClass('text-neutral-300');

        $($iconShowListLastLvl).css('transform', 'rotate(0deg)');
        $($topNavMenuLvl2).find('.top-menu-nav-2-content').find('span').removeClass();

        $($firstLvlLabel).removeClass('hidden').addClass('block');

        $('.menu-level-3, .menu-level-2')
          .addClass(classMenuWindowClose)
          .removeClass(classMenuWindowOpen + ' absolute')
          .addClass('fixed');
        setTimeout(() => {
          $('.menu-level-3, .menu-level-2').css({
            left: '0',
            top: '0',
          });
        }, 0);

        $($topNavMenuLvl2).removeClass('block').addClass('hidden');

        $menuLevel2.removeClass('lg:w-1/2').addClass('w-full');

        $($menuLvl4).each(function () {
          if (!$(this).hasClass('opacity-0')) {
            $(this).addClass('opacity-0 h-auto');
          }
        });
      });

      $previousButtonLastLevel.on('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        $el.find($previousButtonLastLevel).attr('aria-hidden', 'true').attr('tabindex', '-1');
        $(this).parent().closest('.menu-level-2').find('a').removeAttr('aria-hidden');
        $el.find($thirdLvlLabel).attr('aria-hidden', 'true').attr('tabindex', '-1');
        $el.find($fourthLvlLabel).attr('aria-hidden', 'true').attr('tabindex', '-1');
        $menuLevel3.find($thirdLvlLabel).attr('tabindex', '-1');
        $menuLevel3.find($topMenuNavLevel3).find('a').attr('aria-hidden', 'true');
        $menuLevel3.find($topMenuNavLevel3).find('a').attr('tabindex', '-1');


          setTrap({
            el: $(this).parent().closest('.menu-level-2'),
            forceAutofocusEl: $(this).parent().closest('.menu-level-2').find('.nav-back-menu'),
          });

          setTimeout(() => {
            $menuLevel3.removeClass('absolute ' + classMenuWindowOpen)
  
          }, 100);
        $($menuLvl3)
          .addClass(classMenuWindowClose + ' fixed')
          .css({
            left: '0',
            top: '0',
          });
        $menuLevel2.removeClass('lg:w-1/2');
      });
    },
  });
})(Drupal, jQuery);
